import React from "react";
import SubpageBackButton from "../../shared/components/SubpageBackButton";
import { useProfileSubpageBack } from "../../layouts/ProfileSubpageShell";
import "./LegalScreen.css";

export function TermsScreen() {
  return (
    <LegalScreen
      title="Terms & Conditions"
      body="These terms govern your use of Grey Dates. Full legal text will be published here."
    />
  );
}

export function PrivacyScreen() {
  return (
    <LegalScreen
      title="Privacy Policy"
      body="We respect your privacy. This page will describe how Grey Dates collects, uses, and protects your information."
    />
  );
}

function LegalScreen({ title, body }) {
  const goBack = useProfileSubpageBack();

  return (
    <div className="legal-screen">
      <div className="legal-screen__inner">
        <header className="legal-screen__header">
          <SubpageBackButton onClick={goBack} />
          <h1 className="legal-screen__title">{title}</h1>
        </header>
        <p className="legal-screen__body">{body}</p>
      </div>
    </div>
  );
}
